import { render, staticRenderFns } from "./AdminPuzzleForm.vue?vue&type=template&id=28d254ef"
import script from "./AdminPuzzleForm.vue?vue&type=script&lang=js"
export * from "./AdminPuzzleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports